const colors = {
    primary: '#7E7647',
    filter: 'rgba(164, 125, 71, 0.7)'
}

export default colors;